import { useNuxtApp } from "nuxt/app";
import { NUXT_SENRTY } from "~/types/env";

export const useSentry = (err: any, module?: ErrorType, extra?: any) => {
  if (!process.client) return;
  if (!NUXT_SENRTY) return;
  const { $sentry } = useNuxtApp().vueApp;
  if (!$sentry) return;
  $sentry.captureException(err, {
    tags: { module },
    extra,
  });
};

export enum ErrorType {
  /** 网络请求异常 (HTTP 错误、接口超时等) */
  Network = "network_error",
  /** 组件级错误 (Vue 组件内抛出的异常) */
  Component = "component_error",
  /** 资源加载失败 (图片、脚本、样式等) */
  Resource = "resource_error",
  /** 路由/页面初始化错误 */
  PageInit = "page_init_error",
  /** 第三方库错误 (非业务代码抛出的异常) */
  ThirdParty = "third_party_error",
  /** 用户行为异常 (非预期操作流程) */
  UserAction = "user_action_error",
  /** 全局未捕获异常 */
  Global = "global_unhandled_error",
}
